import { jwtDecode } from "jwt-decode";

export const isTokenExpired = (token) => {
  if (!token) return true;
  const { exp } = jwtDecode(token);
  return exp * 1000 < Date.now();
};

export const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const predefinedColors = [
  "magenta",
  "red",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
  "purple",
];

// Function to handle commas in filenames
export const handleFilename = (file) => {
  // Create a new File object with modified name
  if (file.name.includes(",")) {
    //   const newFileName = file.name.replace(/,/g, ''); // Remove all commas
    // Alternative: replace with underscore
    const newFileName = file.name.replace(/,/g, "_");

    const modifiedFile = new File([file], newFileName, { type: file.type });

    // Copy any additional properties from the original file
    Object.defineProperty(modifiedFile, "uid", {
      value: file.uid,
      writable: false,
    });

    return modifiedFile;
  }

  return file;
};
